var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../libs/keybindings');
var Model = require('../libs/Model');
var modal = require('../layout/components/modal');


var addSystemModal = Object.assign(Object.create(Model), require('../../../../models/system/system'));

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


addSystemModal.editDialogue = function (record, parentRecord, options) {
  Model.initForm.call(addSystemModal, record);
  parentRecord && parentRecord['@rid'] ? addSystemModal.form.parent(parentRecord['@rid']) : '';

  var submit = function () {
    addSystemModal.save()
    .then(function (result) {
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close();
      m.redraw();
    })    
  };

  key.setScope('modal');
  key('enter', 'modal', submit);
  modal.vm.title(record ? 'Edit '+record['@class']+': ' : 'Add System: ')
  modal.vm.body = addSystemModal.view.bind(addSystemModal, record, parentRecord, options),
  modal.vm.buttons([
    {
      label: "Save",
      class: record ? "dib mr2 ": "btn-good",
      func: submit
    }
  ]);
  
  modal.vm.open();
}


addSystemModal.view = function (record, parentRecord, options) {
  return m('form', {role:'form'}, [
    addSystemModal.errorView(),
    m('div.form-group', [
      m('label', 'Name'),
      m('input.form-control', {
        oninput: (e) => addSystemModal.form.name(e.target.value),
        value: addSystemModal.form.name()
      })
    ]),
    // Commented to disable this feature until it is fully implemented
    // (() => {
    //   if (!record) {
    //     return m('div.form-group', [
    //       m('label', 'Georeferenced Diagram'),
    //       m('select.form-control', {
    //         onchange: (e) => addSystemModal.form.useGeoPositioning(e.target.value),
    //         value: addSystemModal.form.useGeoPositioning()
    //       }, [
    //         m('option', {value: false}, 'Standard Positioning'),
    //         m('option', {value: true}, 'Use Geo Positioning')
    //       ])
    //     ])
    //   }
    // })()
  ])
}


module.exports = addSystemModal;